import style from './PosLayout.module.scss';
import className from 'classnames/bind';
import { Layout } from 'antd';
import Header from "../Header";
const { Content } = Layout;

const cn = className.bind(style);

function PosLayout({children})
{
	return (
		<div className={cn('wrapper')}>
			<div className={cn('wrapper-inner')}>
				<Layout>
					<Content>
						<div className={cn('content')}>
							{children}
						</div>
					</Content>
				</Layout>
			</div>
		</div>
	);
}

export default PosLayout;